export function normalizeIban(value: string | undefined | null): string {
  return (value ?? '').replace(/[\s-]/g, '').toUpperCase()
}

export function isValidIbanChecksum(value: string | undefined | null): boolean {
  const iban = normalizeIban(value)
  if (iban.length < 15 || iban.length > 34 || !/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) {
    return false
  }

  const rearranged = iban.slice(4) + iban.slice(0, 4)
  const numeric = rearranged
    .split('')
    .map((ch) => (/[A-Z]/.test(ch) ? String(ch.charCodeAt(0) - 55) : ch))
    .join('')

  let remainder = 0
  for (let i = 0; i < numeric.length; i += 7) {
    const block = String(remainder) + numeric.slice(i, i + 7)
    remainder = Number(BigInt(block) % BigInt(97))
  }
  return remainder === 1
}

export function isValidBic(value: string | undefined | null): boolean {
  const bic = (value ?? '').replace(/\s/g, '').toUpperCase()
  return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bic)
}

export function ibanCountryCode(value: string | undefined | null): string {
  const iban = normalizeIban(value)
  return iban.length >= 2 ? iban.slice(0, 2) : ''
}

export function isCurrencyCloudProviderName(name: string | undefined | null): boolean {
  const normalized = (name ?? '').trim().toUpperCase().replace(/[\s_-]+/g, '')
  return normalized === 'CURRENCYCLOUD'
    || normalized === 'CURRENCYCLOUDLIMITED'
    || normalized === 'THECURRENCYCLOUDLIMITED'
}
